import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { TableColumn } from '@eg/ui';
import { ChangeEntryModel } from '@railmybox/api-booking';
import { getHistoryTabsTableColumns } from './history-tab.table';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'rmb-history-tab',
  templateUrl: './history-tab.component.html',
  styleUrl: './history-tab.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HistoryTabComponent implements OnInit {
  private translocoService = inject(TranslocoService);

  @Input() historyItems: ChangeEntryModel[];
  @Input() prefix = 'support';

  tableColumns: TableColumn<ChangeEntryModel>[] = [];
  lang: string;

  ngOnInit() {
    this.lang = this.translocoService.getActiveLang();
    this.tableColumns = getHistoryTabsTableColumns.apply(this);
  }
}
